import React from "react";
import Tempapp from "../src/component/temp";

const App = () => {
  return <Tempapp />;
};

export default App;
